import ModuleStore from './module-store';

const moduleStoreInstace = new ModuleStore();

export default moduleStoreInstace;